import React from "react";
import "./Banner.css";

function Banner() {
  return (
    <div className="banner-container">
      <div className="banner-blur"></div>
      <div className="banner-text">
        <h1>Find student homes</h1>
        <h1>with bills included</h1>
        <h4>A simple and faster way to search for student accommodations</h4>
      </div>
    </div>
  );
}

export default Banner;
